/**
 * 파괴 확인 다이얼로그 — 되돌릴 수 없는 동작(삭제)의 유일한 확인 표면.
 * pending 동안 확인·취소·바깥 닫기가 전부 잠긴다: 확인이 두 번 눌리면 두 번째 요청이 NOT_FOUND 로 실패해
 * 사용자에게 거짓 실패가 보이고, 진행 중 닫히면 결과 통지가 갈 곳을 잃는다. 화면마다 손으로 만들지 않는다(검출기 ⑤).
 */
import { Button, CircularProgress, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { Dialog } from '@/shared/ui/overlays';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

export interface ConfirmDestructiveDialogProps {
  open: boolean;
  title: string;
  message: React.ReactNode;
  confirmLabel: string;
  /** 확인 요청이 진행 중 — 재진입·닫기 잠금 */
  pending: boolean;
  /** pending 과 무관하게 확인을 막아야 할 때(예: 선택이 비었다) */
  confirmDisabled?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function ConfirmDestructiveDialog(p: ConfirmDestructiveDialogProps) {
  return (
    <Dialog open={p.open} onClose={() => { if (!p.pending) p.onCancel(); }}>
      <DialogTitle>{p.title}</DialogTitle>
      <DialogContent><DialogContentText>{p.message}</DialogContentText></DialogContent>
      <DialogActions>
        <Button onClick={p.onCancel} disabled={p.pending}>취소</Button>
        <Button
          onClick={p.onConfirm}
          disabled={p.pending || !!p.confirmDisabled}
          color="error"
          variant="contained"
          startIcon={p.pending ? <CircularProgress size={14} /> : <DeleteOutlineIcon />}
        >
          {p.confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
